import React from "react";
import styles from "./MessageList.module.scss";
import MessagePreview from "./MessagePreview";

/**
 * 메시지 목록 (Figma Message list - node 40004344-51827, 상태 node 40004290-201808)
 * disco 디자인 v3.0.0 - 채팅/메시지 리스트 UI
 * - editMode: true 시 각 행에 체크박스 (status='Edit')
 * - items: status, image, banaccount, previewImageUrl 등 Figma 상태 반영
 */
function MessageList({
  items = [],
  onItemClick,
  editMode = false,
  selectedIds = [],
  onSelectionChange,
  className = "",
}) {

  const isSelected = (item, index) => {
    const id = item.id ?? index;
    return selectedIds.includes(id) || selectedIds.includes(String(id));
  };

  const handleCheck = (item, index, checked) => {
    const id = item.id ?? index;
    if (checked) {
      onSelectionChange?.([...selectedIds, id]);
    } else {
      onSelectionChange?.(selectedIds.filter((s) => s !== id && String(s) !== String(id)));
    }
  };

  return (
    <div className={`${styles.list} ${className}`.trim()} data-name="Message list">
      {items.map((item, index) => (
        <MessagePreview
          key={item.id ?? index}
          name={item.name}
          previewText={item.previewText}
          time={item.time}
          unreadCount={item.unreadCount || 0}
          avatarUrl={item.avatarUrl}
          previewImageUrl={item.previewImageUrl}
          status={editMode ? "Edit" : "Default"}
          image={!!item.image}
          banaccount={!!item.banaccount}
          banaccountByOther={!!item.banaccountByOther}
          notification={item.notification !== false}
          checked={isSelected(item, index)}
          onCheckChange={(checked) => handleCheck(item, index, checked)}
          onClick={() => onItemClick?.(item, index)}
        />
      ))}
    </div>
  );
}

export default MessageList;
export { MessagePreview };
